import { render } from "./ClassImageModal.vue?vue&type=template&id=2c837a8e&scoped=true&ts=true"
import script from "./ClassImageModal.vue?vue&type=script&lang=ts"
export * from "./ClassImageModal.vue?vue&type=script&lang=ts"

import "./ClassImageModal.vue?vue&type=style&index=0&id=2c837a8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c837a8e"]])

export default __exports__